
import AnalysisSummary from '@/components/analysis/AnalysisSummary'
import AnalysisInformation from '@/components/analysis/AnalysisInformation'

import {Component, Vue} from 'vue-property-decorator'
import AnalysisServiceMixin from '@/services/AnalysisServiceMixin'


@Component({
    components: {
        AnalysisSummary,
        AnalysisInformation,
    },
    mixins: [AnalysisServiceMixin],
})

export default class AnalysisAll extends Vue {

}